export enum ActionType {
  APIKSM_DETAILS_BY_PID = "APIKSM_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IAPIKSMProjectDetailsByPid {
  type: ActionType.APIKSM_DETAILS_BY_PID;
  payload: any;
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IAPIKSMProjectDetailsByPid | IResetReduxState;
